/** @jsx jsx */
import { jsx } from "theme-ui"
import Svg from "./base"

const Icon = props => (
  <Svg width="100" height="100" {...props}>
    <path
      fill="#B92A2E"
      d="M74.568 15.426c0-5.202-4.221-9.426-9.436-9.426s-9.45 4.224-9.45 9.426 4.222 9.426 9.45 9.426a9.423 9.423 0 009.436-9.426zm7.318 43.452l.04-18.643c0-9.53-4.43-12.971-12.795-12.971h-8.025c-8.482 0-11.017 4.054-11.593 7.013-1.633 8.383-5.188 13.91-7.554 17.496-8.39 4.824-15.552 3.807-19.682 3.807-5.019 0-7.685 1.577-7.685 7.3l.026 11.2c0 1.655 1.555 3.168 3.359 2.972V90.61a3.34 3.34 0 003.346 3.338 3.34 3.34 0 003.345-3.338 3.34 3.34 0 003.346 3.338 3.331 3.331 0 003.346-3.338l.013-27.247c1.777-.352 4.77-.808 8.168-2.738 0 0 4.235 4.824 8.9-.313.223-.234 2.601-3.22 5.555-8.76l.04 36.894A5.557 5.557 0 0059.602 94a5.557 5.557 0 005.568-5.554c0 3.064 2.496 5.554 5.567 5.554a5.557 5.557 0 005.568-5.554V63.82c1.529.352 5.58.887 5.58-4.94z"
    ></path>
    <path
      fill="#B92A2E"
      d="M63.638 50.08a2 2 0 012.479 0l20.68 16.33c1.489 1.175.657 3.57-1.24 3.57h-41.36c-1.897 0-2.728-2.395-1.24-3.57l20.68-16.33zm-32.225-3.04c0-3.832-3.11-6.935-6.953-6.935-3.843 0-6.953 3.103-6.953 6.936 0 3.833 3.11 6.935 6.953 6.935 3.842 0 6.953-3.115 6.953-6.935z"
    ></path>
  </Svg>
)

export default Icon
